// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { MainSidebar } from '../components/mainsidebar'

export class Help extends Component {
    constructor(props) {
        super(props)

        this.state = {
        }

        this.init()

        this.init = this.init.bind(this)
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            console.log("Not logged in")
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            if (storedData.profileType === 'worker') {
                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    average_strikes: storedData.average_strikes,
                    confirmed: storedData.confirmed,
                    email: storedData.email,
                    gender: storedData.gender,
                    purpose: storedData.purpose,
                    uid: storedData.uid,
                    first_name: storedData.first_name,
                    last_name: storedData.last_name,
                    last_active_at: storedData.last_active_at,
                    workers: JSON.parse(storedData.workers),
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleWorkerDataUpdateFromSessionStorage(data)
            }
            else {
                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    id: storedData.uid,
                    admin_first_name: storedData.fname,
                    admin_last_name: storedData.lname,
                    name: storedData.company,
                    address: storedData.address,
                    email: storedData.email,
                    license_count: storedData.licenseCount,
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleProviderDataUpdateFromSessionStorage(data)
            }
        }

        if (this.props.appData.authToken !== '') {
            this.data = this.props.appData
        }
        else {
            this.data = window.sessionStorage
        }
    }

    mainBody() {
        return (
            <div className="main-body">
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            <h2 className="title">Help</h2>
                        </div>

                    </Col>
                </Row>
                <Row>
                    <Col xsOffset={1} xs={10} smOffset={1} sm={10} mdOffset={1} md={10}>
                        <Row>
                            <h3 className="category-title">App Download</h3>
                            <p>Looking for the Enabler app? Click on one of the links below:</p>
                            <Col md={1}>
                                <p><a href="https://apps.apple.com/au/app/enabler/id1423438333">
                                    <img src="/assets/images/app-store-badge.png" alt="download-app-store" style={{ width: 256, height: 76 }} />
                                </a></p>
                                <p><a href="https://play.google.com/store/apps/details?id=com.enablerinteractive.enabler.android.Enabler">
                                    <img src="/assets/images/google-play-badge.png" alt="download-google-play" style={{ width: 256, height: 76 }} />
                                </a></p>
                            </Col>
                        </Row>
                        <Row>
                            <h3 className="category-title">Technical Support</h3>
                            <p>In need of technical support? Click on the image below to visit our support desk:</p>
                            <Col md={2}>
                                <p><a href="https://enablerinteractive.atlassian.net/servicedesk/customer/portal/1">
                                    <img src="/assets/images/support_desk.jpg" alt="support-desk" style={{ width: 512, height: 270, border: "5px solid #d4d4d4" }} />
                                </a></p>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6}>
                                <h3 className="category-title">What's New?</h3>
                                <h4>30 Apr 2024</h4>
                                <li>Summary data for organisation accounts now include worker totals for those In Progress and Not Started on training content</li>
                                <li>Added support for custom logos on organisation invite links</li>
                                <li>Let us know how to fulfil your needs by filling in your Settings profile (worker accounts only)</li>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }

    render() {
        return (
            <div className="help-container page-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={3}
                    appData={this.data}
                />
                {this.mainBody()}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/help.js